export default __webpack_public_path__ + "media/images/images_v2/titre-shade-2f2d6b6f6812b061063d94cb42e1f78e.png";